const paypalStyles = {
    label: "paypal",
    size: "responsive",
    shape: "rect",
    color: "gold",
    tagline: false
};

export default paypalStyles;
